import * as React from 'react';

import { SxProps, Typography as MatTypography, Theme } from '@mui/material';
type TypographyAlignment = 'inherit' | 'left' | 'right' | 'center' | 'justify';
type TypographyColor = 'default' | 'error' | 'inherit' | 'primary' | 'secondary' | 'textPrimary' | 'textSecondary';

type TypographyVariants = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'caption' | 'button' | 'overline';

type AriaLiveOptions = 'off' | 'polite' | 'assertive';

export interface TypographyProps {
  variant?: TypographyVariants;
  component?: React.ElementType;
  align?: TypographyAlignment;
  color?: TypographyColor;
  className?: string;
  title?: string;
  id?: string;
  ref?: any;
  ariaLive?: AriaLiveOptions;
  role?: string;
  sx?: SxProps<Theme>;
}

const Typography: React.FunctionComponent<TypographyProps> = ({ children, color, component, ariaLive, sx, ...restProps }) => {
  return (
    <MatTypography color={color as any} {...restProps} component={component as any} aria-live={ariaLive} sx={sx}>
      {children}
    </MatTypography>
  );
};

Typography.defaultProps = {
  color: 'inherit'
};

Typography.displayName = 'Typography';

export { Typography };
